import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, getCookie, setCookie } from "../Helpers";
import {
  MdArrowCircleLeft,
  MdArrowCircleRight,
  MdLogin,
  MdLock,
  MdPhoneAndroid,
  MdOutlinePhonelinkLock,
  MdPassword
} from "react-icons/md";
import {
  STR_CHANGE_LANGUAGE,
  STR_CONFIRM,
  STR_CONTINUE,
  STR_ENTER_OTP,
  STR_ENTER_YOUR_PHONE_NUMBER,
  STR_INVALID_OTP,
  STR_INVALID_PHONE,
  STR_LOGIN_TO_CONTINUE,
  STR_PHONE_NUMBER,
  STR_PLEASE_WAIT,
  STR_RESEND_OTP,
  STR_WELCOME,
  STR_YOUR_OTP_VERIFICATION,
  STR_CHANGE_PHONE
} from "../Strings";

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [loginStep, setLoginStep] = useState("identity");

  async function init() {
    const storedPhone = getCookie("phone");
    const storedLoginStep = getCookie("loginStep");

    if (storedLoginStep) {
      setLoginStep(storedLoginStep);
      if (storedPhone) setPhone(storedPhone);
    }
  }

  function resetStep() {
    setCookie('phone', '', -100000);
    setCookie('loginStep', '', -100000);
    setLoginStep('identity');
    setOtp('');
  }

  async function phoneLogin() {
    if (!loading) {
      if (String(phone).trim().length >= 9) {
        setLoading(true);
        await callApi("phone-login", {
          phone: `255${parseInt(phone, 10)}`,
        }).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);
      } else {
        appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  async function resendOtp() {
    if (!loading) {
      setLoading(true);
      await callApi("resend-otp", {
        phone: `255${parseInt(phone, 10)}`,
      }).then((response) => {
        if (response.status === 1) {
          setLoginStep(response.nextLoginStep);
        } else {
          appContext.tellError(response.msg);
        }
      })
      setLoading(false);
    }
  }

  async function otpLogin() {
    if (!loading) {
      if (otp.trim().length === 6) {
        setLoading(true);
        await callApi("otp-login", {
          phone: `255${parseInt(phone, 10)}`,
          otp,
        }).then((response) => {
          if (response.status === 1) {
            setCookie("userId", response.user.id);
            setCookie("userToken", response.user.token);
            appContext.navTo({ item: 'scan' });
            appContext.refresh();
            appContext.tellMessage(STR_WELCOME[appContext.language]);
            resetStep();
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);
      } else {
        appContext.tellError(STR_INVALID_OTP[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])

  return (
    <div
      className="bg-sub-gradient d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >

      {/* PHONE STEP */}
      {
        loginStep === "identity" &&
        <div className="container">
          <div
            className="mShadow3 bg-surface mx-auto"
            style={{
              maxWidth: "420px",
              padding: "35px",
              borderRadius: "22px"
            }}
          >

            <div className="text-center mb-4">
              <img src={logo_worded_only} alt="Kamola LandLink" style={{ height: "38px" }} />
              <h5 className="font-bold mt-3">
                {STR_LOGIN_TO_CONTINUE[appContext.language]}
              </h5>
            </div>

            <label className="form-label font-semi-bold">
              <MdPhoneAndroid size={18} className="me-2 text-primary" />
              {STR_PHONE_NUMBER[appContext.language]}
            </label>

            <div className="input-group mb-3">
              <span className="input-group-text">+255</span>
              <input
                className="form-control"
                placeholder="712 345 678"
                maxLength={10}
                value={phone}
                onChange={(e) => {
                  if (Number(e.target.value) || e.target.value === "") {
                    setPhone(e.target.value);
                  }
                }}
              />
            </div>

            <div className="form-text mb-4">
              {STR_ENTER_YOUR_PHONE_NUMBER[appContext.language]}
            </div>

            <button
              className="btn btn-primary btn-rounded btn-padded w-100"
              style={{ textTransform: "uppercase" }}
              onClick={phoneLogin}
            >
              <MdLogin className="me-2" />
              {STR_CONTINUE[appContext.language]}
            </button>

            <div
              className="text-center mt-4 text-primary font-bold"
              style={{ cursor: "pointer", fontSize: "14px" }}
              onClick={() => appContext.changeLanguage()}
            >
              <MdArrowCircleRight size={16} /> {STR_CHANGE_LANGUAGE[appContext.language]}
            </div>
          </div>
        </div>
      }

      {/* OTP STEP */}
      {
        loginStep === "otp" &&
        <div className="container">
          <div
            className="mShadow3 bg-surface mx-auto"
            style={{
              maxWidth: "420px",
              padding: "35px",
              borderRadius: "22px"
            }}
          >

            <div className="text-center mb-4">
              <MdOutlinePhonelinkLock size={42} className="text-primary mb-2" />
              <h5 className="font-bold">
                {STR_YOUR_OTP_VERIFICATION[appContext.language]}
              </h5>
            </div>

            <label className="form-label font-semi-bold">
              <MdPassword size={18} className="me-2 text-primary" />
              OTP
            </label>

            <input
              className="form-control text-center"
              style={{
                fontSize: "20px",
                letterSpacing: "6px",
                fontWeight: "bold"
              }}
              maxLength={6}
              value={otp}
              onChange={(e) => {
                if (/^\d*$/.test(e.target.value)) {
                  setOtp(e.target.value);
                }
              }}
              placeholder="• • • • • •"
            />

            <div className="form-text text-center mt-3">
              {STR_ENTER_OTP[appContext.language]}
            </div>

            <button
              className="btn btn-primary btn-rounded btn-padded w-100 mt-4"
              onClick={otpLogin}
            >
              <MdLock className="me-2" />
              {STR_CONFIRM[appContext.language]}
            </button>

            <div className="mt-4">
              <div
                className="text-primary font-bold"
                style={{ cursor: "pointer", fontSize: "14px" }}
                onClick={resetStep}
              >
                <MdArrowCircleLeft size={16} /> {STR_CHANGE_PHONE[appContext.language]}
              </div>

              <div
                className="text-primary font-bold mt-2"
                style={{ cursor: "pointer", fontSize: "14px" }}
                onClick={resendOtp}
              >
                <MdArrowCircleRight size={16} /> {STR_RESEND_OTP[appContext.language]}
              </div>
            </div>

          </div>
        </div>
      }

    </div>
  )
}
